var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97262 0 0.00020361 8.83446 0.00020361 19.68C-0.0722957 35.5446 19.24 48.6991 20 49.2308C20 49.2308 40.0723 35.5446 39.9998 19.6923C39.9998 8.83446 31.0274 0 20 0ZM20 29.5385C14.4751 29.5385 10.0001 25.1323 10.0001 19.6923C10.0001 14.2523 14.4751 9.84616 20 9.84616C25.525 9.84616 29.9999 14.2523 29.9999 19.6923C29.9999 25.1323 25.525 29.5385 20 29.5385Z",
    fill: "#008DAF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 12.5H13.25V20.375C13.25 21.6406 14.2344 22.625 15.5 22.625H22.25C23.4805 22.625 24.5 21.6406 24.5 20.375V19.25V18.125V12.5H23.9375H23.375ZM25.625 20.375C25.625 22.2383 24.1133 23.75 22.25 23.75H15.5C13.6367 23.75 12.125 22.2383 12.125 20.375V12.5C12.125 11.9023 12.6172 11.375 13.25 11.375H23.375H23.9375H24.5H27.3125C29.457 11.375 31.25 13.168 31.25 15.3125C31.25 17.4922 29.457 19.25 27.3125 19.25H25.625V20.375ZM27.3125 18.125C28.8594 18.125 30.125 16.8945 30.125 15.3125C30.125 13.7656 28.8594 12.5 27.3125 12.5H25.625V18.125H27.3125ZM9.3125 26H28.4375C28.7188 26 29 26.2812 29 26.5625C29 26.8789 28.7188 27.125 28.4375 27.125H9.3125C8.99609 27.125 8.75 26.8789 8.75 26.5625C8.75 26.2812 8.99609 26 9.3125 26Z",
    fill: "#008DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.aadc61bf490fbaeb638e5f45b7c1c0d2.svg";
export { ForwardRef as ReactComponent };